// extracted by mini-css-extract-plugin
export default {"cardDiv":"BannerCard_cardDiv__OCS+x","heading":"BannerCard_heading__WIrCH"};